import axios from 'axios';

axios.defaults.baseURL = '/v2/api/search';

export function fetchKeywordSuggestions(keyword) {
  return axios.get('/keyword_suggestions', {
    params: {
      keyword: keyword
    }
  });
}
